var map = {
	"./1-AX.png": 19627,
	"./2-AX.png": 46407,
	"./3-AX.png": 70448,
	"./4-AX.png": 36185,
	"./5-AX.png": 96151,
	"components/Catalog/AX/img/glass/mt/mtPlusBronze/1-AX.png": 19627,
	"components/Catalog/AX/img/glass/mt/mtPlusBronze/2-AX.png": 46407,
	"components/Catalog/AX/img/glass/mt/mtPlusBronze/3-AX.png": 70448,
	"components/Catalog/AX/img/glass/mt/mtPlusBronze/4-AX.png": 36185,
	"components/Catalog/AX/img/glass/mt/mtPlusBronze/5-AX.png": 96151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39049;